
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';
import { ARServiceItem, ARServiceItemList } from '@/models/airRoad';
import { extend } from 'vee-validate';
import { required, regex } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required',
});
extend('regex', {
  ...regex,
  message: 'Numbers only',
});
@Component({
  components: { Button },
})
export default class ServicesForm extends Vue {
  @Prop(Object) ARServicesList!: ARServiceItemList;
  @Prop(Object) serviceItem!: ARServiceItem;

  public isArServiceDisabled(code: string): boolean {
    if (
      code === 'AMSrv' &&
      (this.ARServicesList['PMSrv']?.chosen ||
        this.ARServicesList['DelTime']?.chosen ||
        this.ARServicesList['PckUpTime']?.chosen)
    ) {
      return true;
    }
    if (
      code === 'PMSrv' &&
      (this.ARServicesList['AMSrv']?.chosen ||
        this.ARServicesList['DelTime']?.chosen ||
        this.ARServicesList['PckUpTime']?.chosen)
    ) {
      return true;
    }
    if (
      code === 'DelTime' &&
      (this.ARServicesList['AMSrv']?.chosen ||
        this.ARServicesList['PMSrv']?.chosen ||
        this.ARServicesList['PckUpTime']?.chosen)
    ) {
      return true;
    }
    if (
      code === 'PckUpTime' &&
      (this.ARServicesList['AMSrv']?.chosen ||
        this.ARServicesList['PMSrv']?.chosen ||
        this.ARServicesList['DelTime']?.chosen)
    ) {
      return true;
    }
    return false;
  }
}
